import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { News } from '../../models';

import { ImageComponent } from '@teamfoster/sdk/image';
import { StripHtmlPipe } from '@teamfoster/sdk/text-utility';
import { RouterLink } from '@angular/router';
import { NewsDatePipe } from '../../pipes/news-date.pipe';

@Component({
    selector: 'app-news-card',
    imports: [ImageComponent, StripHtmlPipe, RouterLink, NewsDatePipe],
    templateUrl: './news-card.component.html',
    styleUrl: './news-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsCardComponent {
  news = input.required<News>();
}
